import {
    ApiParameter,
    API_URL_CURRENT_FRAGMENT,
    doesNotHaveExpand,
    get,
    HasPagingParameters,
} from "@insite/client-framework/Services/ApiService";
import { BillToModel, ShipToCollectionModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

export interface GetBillToApiParameter extends ApiParameter {
    billToId: string;
    expand?: ("shipTos" | "accountsReceivable" | "excludeOneTime" | "validation" | "costCodes")[];
    additionalExpands?: string[];
}

export interface UpdateBillToApiParameter extends ApiParameter {
    billTo: BillToModel;
}

export interface GetShipToApiParameter extends ApiParameter {
    billToId: string;
    shipToId: string;
    expand?: "validation"[];
    additionalExpands?: string[];
}

export interface UpdateShipToApiParameter extends ApiParameter {
    billToId: string;
    shipTo: ShipToModel;
}

export interface GetShipTosApiParameter extends ApiParameter, HasPagingParameters {
    expand?: ("validation" | "approvals" | "assignedOnly" | "excludeShowAll" | "excludeOneTime" | "excludeCreateNew")[];
    exclude?: ("showAll" | "createNew" | "billTo" | "oneTime")[];
    additionalExpands?: string[];
    filter?: string;
    billToId?: string;
}

export interface GetBillTosApiParameter extends ApiParameter, HasPagingParameters {
    expand?: ("shipTos" | "state" | "excludeOneTime")[];
    additionalExpands?: string[];
    filter?: string;
}

export interface CreateShipToApiParameter extends ApiParameter {
    billToId?: string;
    shipTo: ShipToModel;
}

export interface UpdateEnforcementLevelApiParameter extends ApiParameter {
    billTo: BillToModel;
}

const billTosUrl = "/api/v1/billtos";

export async function getShipTos(parameter: GetShipTosApiParameter) {
    const billToId = parameter.billToId || API_URL_CURRENT_FRAGMENT;
    const storedItemCount = localStorage.getItem("itemCount");
    if (storedItemCount) {
        parameter = {
            ...parameter,
            pageSize: Number(storedItemCount) + 1,
        };
    } else {
        parameter = {
            ...parameter,
            pageSize: 500,
        };
    }

    const shipTos = await get<ShipToCollectionModel>(`${billTosUrl}/${billToId}/shiptos`, parameter);
    const shipToTotalItemCount = shipTos.pagination?.totalItemCount;
    if (shipToTotalItemCount && !parameter.filter) {
        const shipToPageSize = shipToTotalItemCount + 3;
        localStorage.setItem("itemCount", JSON.stringify(shipToPageSize));
    }
    shipTos.shipTos?.forEach(o => cleanShipToModel(o, parameter));
    return shipTos;
}

function cleanShipToModel(shipToModel: ShipToModel, parameter?: { expand?: string[]; additionalExpands?: string[] }) {
    if (doesNotHaveExpand(parameter, "validation")) {
        shipToModel.validation = null;
    }
    if (shipToModel.id.trim() === "") {
        shipToModel.id = shipToModel.label;
    }

}
